var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "operating-activities"
  }, [_c("section", {
    staticClass: "operating-activities__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "活动运营中台",
      description: "\n        运营中台是一款适用于证券等行业的活动营销工具，它整合了同花顺多年的运营经验及技术能力赋能行业实现自动化营销，\n        高效便捷地助力APP运营者实现快速拉新、留存、促活，不断提升用户转化率。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "operating-activities__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "operating-activities__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "operating-activities__skill-wrapper"
  }, [_c("Skill", {
    staticClass: "area",
    attrs: {
      skillList: _vm.skillList
    }
  })], 1), _c("section", {
    staticClass: "operating-activities__cases-wrapper"
  }, [_c("Cases")], 1), _c("section", {
    staticClass: "operating-activities__appointment-wrapper"
  }, [_c("Appointment2", {
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };